import FileSaver from 'file-saver'

export default function ({blob = null, fileName, headers = {}}) {
  let headerFileName = null
  if (headers['content-disposition']) {
    // attachment; filename="DataBankOfTechnologies.xlsx"
    let isUtf8 = headers['content-disposition'].indexOf('*=utf-8') > -1
    // TODO: use ascii \x
    let fileNameRegex = isUtf8
      ? /utf-8''([\s\w%.;&-=+*]+)/
      : /filename="(.*?)"/
    let found = headers['content-disposition'].match(fileNameRegex)
    console.log(headers['content-disposition'], found)
    if (found !== null && found.length > 1) {
      headerFileName = isUtf8
        ? decodeURIComponent(found[1])
        : found[1]
    }
  }
  FileSaver.saveAs(blob, headerFileName || fileName)
}
